/**
 * Combos y recetas en lo ya guardado (spec 20, regla 7): el detalle del documento, la nota de entrega, la cotización y
 * su impresión llevan una cabecera con el nombre del combo y su medida antes de su primer renglón. La factura no.
 */
import type { ComboEnDocumentoDTO } from '@mg/shared';
import { textoMedida } from './carrito.ts';

/** El combo cuya cabecera va antes del renglón `i` (es el primero de su grupo), o null. */
export function cabeceraDeCombo(combos: readonly ComboEnDocumentoDTO[] | undefined, lineas: readonly { combo_grupo?: string | null | undefined }[], i: number): ComboEnDocumentoDTO | null {
  const g = lineas[i]?.combo_grupo;
  if (!g || lineas.findIndex((l) => l.combo_grupo === g) !== i) return null;
  return combos?.find((k) => k.grupo === g) ?? null;
}

/** «Techo en dry wall · 26 m²», «Kit de baño · 3 combos». */
export function tituloCombo(k: Pick<ComboEnDocumentoDTO, 'nombre' | 'tipo' | 'unidad_medida' | 'medida'>): string {
  return `${k.nombre} · ${textoMedida(k)}`;
}
